"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgLink = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M22.425 20.01a6 6 0 014.376 2.391 1 1 0 11-1.602 1.198 4 4 0 00-6.032-.432l-2.988 2.988a4 4 0 00.049 5.607c1.543 1.543 4.038 1.565 5.595.06l1.71-1.71a1 1 0 011.414 1.415l-1.722 1.722a6 6 0 01-8.472-8.496l3-3a6 6 0 014.672-1.743zm10.761-5.186a6.004 6.004 0 01.061 8.423l-3 3a6 6 0 01-9.048-.648 1 1 0 111.602-1.198 4 4 0 006.032.432l2.988-2.988a4 4 0 00-.049-5.607 3.997 3.997 0 00-5.597-.059l-1.72 1.71a1 1 0 11-1.41-1.418l1.73-1.72a6 6 0 018.411.073z",
    id: "link_svg__a"
  }));
};

var _default = SvgLink;
exports.default = _default;